import { z } from "@hono/zod-openapi";

export const ValidationIssue = z
  .object({
    path: z.array(z.union([z.string(), z.number()])),
    code: z.string(),
    message: z.string(),
  })
  .openapi("ValidationIssue");

export const ValidationErrorResponse = z
  .object({
    error: z.literal("validation_error"),
    issues: z.array(ValidationIssue),
  })
  .openapi("ValidationErrorResponse");

export type ValidationIssue = z.infer<typeof ValidationIssue>;
export type ValidationErrorResponse = z.infer<typeof ValidationErrorResponse>;

type IssueLike = {
  path: readonly (string | number | symbol)[];
  code: string;
  message: string;
};

export function validationErrorResponse(issues: readonly IssueLike[]): ValidationErrorResponse {
  return {
    error: "validation_error",
    issues: issues.map((issue) => ({
      path: issue.path.map((segment) =>
        typeof segment === "symbol" ? segment.toString() : segment,
      ),
      code: issue.code,
      message: issue.message,
    })),
  };
}
